import React, { useState } from 'react'
import './styles.scss'
import { Collapse } from 'react-bootstrap'
import ToggleButton from 'components/atoms/ToggleButton'

interface SimpleCardWithIconProps {
  children?: React.ReactNode
  showText?: string
  hideText?: string
}

const StyledAccordion = ({
  children,
  showText,
  hideText
}: SimpleCardWithIconProps): JSX.Element => {
  const [open, setOpen] = useState(false)
  return (
    <div className='ui-styled-accordion'>
      <ToggleButton
        isOpen={open}
        onClick={() => setOpen(!open)}
        showText={showText}
        hideText={hideText}
      />
      <Collapse in={open}>
        <div id='example-collapse-text'>{children}</div>
      </Collapse>
    </div>
  )
}

export default StyledAccordion
